SidebarKo = App.loadClass "core::viewmodels/filters/Sidebar"

class exports.Hybrids_Handler extends Handler

    init: () ->
        @layoutUrl = 'backend/portal/hybrids/'
        @loadLayout()

    afterLoadLayout: () ->
        filters = [
            {
                name: 'Inventory Filters',
                filters: [
                    {
                        name: 'crops'
                        display_name: 'Crop'
                    },
                    {
                        name: 'status'
                        display_name: 'Status'
                        deletable: false
                        control_type: 'single_dropdown'
                        values: [
                            { key: 'all', value: 'All' },
                            { key: 'disabled', value: 'Disabled' },
                            { key: 'enabled', value: 'Enabled' }
                        ],
                        selected_values: [
                            { key: 'all', value: 'All' }
                        ]
                    }
                ],
            },
        ]


        @sidebar = new SidebarKo filters
        ko.applyBindings @sidebar, $(@layoutSelector)[0]

        @sidebar.fetchFilters 'backend/portal/hybrids/filters', () =>
            @hybrids_dialog = @createSubHandler 'portal::handlers/hybrids/Hybrids_Dialog'
            if @hybrids_dialog
                @hybrids_dialog.init()


        # Event Listener for Apply Filter button
        $(@layoutSelector).find('.apply-filters').bind 'click', () =>
            @hybrids_dialog.refresh()


        # Allow toggling open/closed on "filtering by"
        $(@layoutSelector).find('.report-applied-filters').undelegate().delegate '.applied-filter-header', 'click', () ->
            $(this).siblings('.applied-filter-value-container').slideToggle('fast')
            if $(this).find('.caret-arrow').hasClass('caret-right')
                $(this).find('.caret-arrow').removeClass('caret-right')
            else
                $(this).find('.caret-arrow').addClass('caret-right')
